<template>
  <Layout is-demo>
    <h1 class="text-h4 ms-0 mb-1">Dashboard</h1>
    <!--<v-alert 
      dense 
      text 
      icon="mdi-bullhorn" 
      colored-border
      type="success"
      elevation="2"
      border="bottom"
    >
      There is a waiver for late renewal till the 31 of August 2025</v-alert>-->
    <v-row>
      <v-col cols="12" md="6">
        <v-card v-if="dashboardIsLoadedFM" style="min-height: 132px" class="rounded-3">
          <div class="pa-0">
            <v-toolbar color="light-green" dark dense flat>
              <v-icon color="white" x-large>mdi-certificate</v-icon>
              <v-toolbar-title color="white" class="font-weight-bold text-body-1 px-2">
                Certificate Info
              </v-toolbar-title>
            </v-toolbar>
            <div class="d-flex align-center pa-2 h6">
              <div>
                <div class="">
                  <b>Line Of Business:</b> {{ currentLOBDetails.LOBname }}
                </div>
                <div class="">
                  <b>Certificate Number:</b>
                  {{ dashboardData.certificateNumber }}
                </div>
                <div class="">
                  <b>Certificate Expiry Date:</b>
                  {{ dashboardData.certificateExpiryDate }}
                </div>
                <div class="">
                  <b>Certificate Status:</b>
                  {{ dashboardData.certificateStatus }}
                </div>
                <div class="">
                  <b>Period Elaped:</b> {{ dashboardData.period_elaped }}
                </div>
              </div>
            </div>
          </div>
        </v-card>
        <v-sheet v-else class="pa-3">
          <v-skeleton-loader class="mx-auto" type="list-item-avatar,list-item" max-height="132px"></v-skeleton-loader>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="6">
        <v-card v-if="dashboardIsLoadedFM" style="min-height: 132px" class="rounded-3">
          <div class="pa-0">
            <v-toolbar color="light-green" dark dense flat>
              <v-icon color="white" x-large>mdi-account</v-icon>
              <v-toolbar-title color="white" class="font-weight-bold text-body-1 px-2">
                Account Info
              </v-toolbar-title>
            </v-toolbar>
            <div class="d-flex align-center pa-2 h6">
              <div>
                <div class=""><b>TIN:</b> {{ dashboardData.TIN }}</div>
                <div class="">
                  <b>RC Number:</b> {{ dashboardData.CAC_registration_number }}
                </div>
                <div class="">
                  <b>Operational State:</b>
                  {{ dashboardData.state_of_residence }}
                </div>
                <div class="">
                  <b>Contact Email:</b> {{ dashboardData.email }}
                </div>
                <div class="">
                  <b>Contact Phone:</b> {{ dashboardData.phone }}
                </div>
              </div>
            </div>
          </div>
        </v-card>
        <v-sheet v-else class="pa-3">
          <v-skeleton-loader class="mx-auto" type="list-item-avatar,list-item" max-height="132px"></v-skeleton-loader>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="12">
        <v-card style="min-height: 132px" class="rounded-3">
          <div class="pa-0">
            <v-toolbar color="light-green" dark dense flat>
              <v-icon color="white" x-large>mdi-cash</v-icon>
              <v-toolbar-title color="white" class="font-weight-bold text-body-1 px-2">
                Payment Info
              </v-toolbar-title>
            </v-toolbar>
            <div class="d-flex align-center pa-2 h6">
              <div>
                The total amount is the sum total of the renewal fee and the
                penalty for late renewal (if your have defaulted).<br />
                You can only activate this process when your certificate:
                <ul>
                  <li>have expired</li>
                  <li>have three or less months to expire</li>
                </ul>
                <br />
                To renew your certificate/permit(make payment), click on the
                <b>Activate Renewal Process</b> button below <br /><br />
                <div class="">
                  <b>Renewal Fee:</b> {{ dashboardData.renewal_fee | nairaFormatter }}
                </div>
                <div class="">
                  <b>Penalty/Late Renewal:</b> {{ dashboardData.waiver }}{{ dashboardData.penalty | nairaFormatter }}
                </div>
                <div class="">
                  <b>Total Amount:</b> {{ dashboardData.total_amount | nairaFormatter }}
                </div>
                <div v-if="showActivationButt" class="d-flex align-center pa-2 h6">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2 px-2"
                    outlined
                    @click="activateRenewal"
                  >
                    Activate Renewal Process
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </Layout>
</template>

<script>
import Layout from '@/nfmp_components/layouts/MainPortalLayout'
import httpServ from '../services/HTTPService'
//import { Plotly } from 'vue-plotly'

export default {
  components: {
    Layout
  },
  data() {
    return {
      alterLOBFlag: false,
      someDate: '2023-05-03 00:00:00',
      memberData: {},
      dashboardData: {
        main_line_of_business: 'loading...',
        second_line_of_business: '',
        state_of_residence: 'loading...',
        company_address: 'loading...',
        TIN: 'loading...',
        CAC_registration_number: 'loading...',
        phone: 'loading...',
        email: 'loading...',
        certificateNumber: 'loading...',
        certificateExpiryDate: 'loading...',
        certificateStatus: 'loading...',
        membership_id: 'loading...',
        period_elaped: 'loading...',
        production_category: '',
        renewal_fee: 0.0,
        penalty: 0.0,
        total_amount: 0.0,
        total_days: 0,
        waiver: ''
      },
      d_member: {},
      d_member_is_set: false,
      d_cert: {},
      d_cert_is_set: false,
      d_fee: {},
      d_fee_is_set: false,
      d_invalidatedData: false,
      showActivationButt: false,
      activationDays: 90,

      dashboardIsLoadedFR: false,
      dashboardIsLoadedFM: true,
      tableIsLoaded: false,
      prePostData: {},
      currentLOBDetails: {},
      showAlert: true,
      fees: [],
      currentLOBname: ''
    }
  },
  created() {
    this.memberData = httpServ.getSessionJson('memberData')
    //console.log(this.memberData)
    this.currentLOBDetails.memberStatus =
      this.memberData.lobs[this.memberData.displayLOB].membership_status
    this.currentLOBDetails.LOBId =
      this.memberData.lobs[this.memberData.displayLOB].line_of_business_id
    this.currentLOBDetails.LOBname =
      this.memberData.lobs[this.memberData.displayLOB].line_of_business_name
    this.prePostData = {
      //jwtToken: this.memberData.jwt,
      membership_id: this.memberData.membership_id,
      LOB_id:
        this.memberData.lobs[this.memberData.displayLOB].line_of_business_id,
      lOB: this.memberData.lobs[
        this.memberData.displayLOB
      ].line_of_business_name.replace('Fertilizer ', '')
    }
    this.getDisplayData4FullMemership()
    this.getCertificateDetails()
    this.getFee()
  },
  mounted() {
    this.$root.$on('get-dashbardTable-data', () => {
      this.getTableData()
    })
  },
  methods: {
    getDisplayData4FullMemership: function () {
      const url = httpServ.getSlime4MemberUrl201('/certificates/renewal/dashboard')
      //const url = httpServ.getMemberUrl('/renewal/renewalDashboard')
      const resp = httpServ.postFetchWithJWT(
        url,
        this.prePostData,
        this.memberData.jwt
      )

      resp.then((result) => {
        this.d_member = result.data
        this.d_member_is_set = true
        this.checkRecievedData()
      })
    },
    getCertificateDetails: function () {
      const url = httpServ.getCertificateUrl('/member/getCertificateDetails')
      const resp = httpServ.postFetchWithToken(
        url,
        this.prePostData,
        httpServ.getPaymentApiToken()
      )

      try {
        resp.then((result) => {
          if (result.status === 200) {
            //this.d_cert = JSON.parse(result.data)
            this.d_cert = result.data
          } else {
            this.d_invalidatedData = true
          }
          this.d_cert_is_set = true
          this.checkRecievedData()
        })
      } catch (error) {
        console.error('Error parsing JSON:', error)
        const responseText = resp.clone().text()

        console.error('Raw response text:', responseText)
      }
    },
    makePlural: function (period, str) {
      if (period > 1) {
        return str + 's'
      } else {
        return str
      }
    },
    getFee: function () {
      const url = httpServ.getPaymentUrl('/fees/renewal')
      const resp = httpServ.postFetchWithToken(
        url,
        this.prePostData,
        httpServ.getPaymentApiToken()
      )

      resp.then((result) => {
        this.d_fee = result.data
        this.d_fee_is_set = true
        this.checkRecievedData()
      })
    },
    checkRecievedData: function () {
      if (
        this.d_cert_is_set === true &&
        this.d_fee_is_set === true &&
        this.d_member_is_set === true
      ) {
        this.setFields()
      }
    },
    invalidateRecievedData: function () {
      this.dashboardData.certificateExpiryDate = 'NOT FOUND'
      this.dashboardData.certificateStatus = 'UNKNOWN'
      this.dashboardData.certificateNumber = 'UNKNOWN'
      this.dashboardData.period_elaped = 'UNKNOWN'
      this.showActivationButt = false
      this.dashboardData.period_elaped = 'None'
      this.d_cert.certificate_expiration_date = 'UNKNOWN'
      this.d_cert.expiration_details = {
        status: 'UNKNOWN'
      }
    },
    getElapsePeriod: function (details) {
      let period_elaped = ''
      let total_days = 0

      if (details.years > 0) {
        period_elaped +=
          details.years + this.makePlural(details.years, ' year')
        total_days += 365 * details.years
        //console.log('years in days:' + days)
      }
      if (details.months > 0) {
        if (period_elaped.length > 0) {
          period_elaped += ', ' + details.months + this.makePlural(details.months, ' month')
        } else {
          period_elaped += details.months + this.makePlural(details.months, ' month')
        }
        total_days += 30 * details.months
        //console.log('month in days:' + this.dashboardData.total_days)
      } else {
        //days_remaining += 30 * this.d_cert.expiration_details.months
      }

      if (details.days > 0) {
        if (period_elaped.length > 0) {
          period_elaped += ' and ' + details.days + this.makePlural(details.days, ' day')
        } else {
          period_elaped += details.days + this.makePlural(details.days, ' day')
        }
        total_days += details.days
        //console.log('days in days:' + this.dashboardData.total_days)
      } else {
        //days_remaining += this.d_cert.expiration_details.days
      }
      this.dashboardData.total_days = total_days

      return period_elaped
    },
    setFields: function () {
      //member
      this.dashboardData.TIN = this.d_member.company.TIN
      this.dashboardData.CAC_registration_number =
        this.d_member.company.CAC_registration_number
      this.dashboardData.phone = this.d_member.contact.phone
      this.dashboardData.email = this.d_member.contact.email
      this.dashboardData.state_of_residence =
        this.d_member.location.state_of_residence
      this.dashboardData.production_category =
        this.d_member.company.production_category

      //cert
      if (this.d_invalidatedData) {
        this.invalidateRecievedData()
      } else {
        this.dashboardData.certificateExpiryDate =
          this.d_cert.certificate_expiration_date
        this.dashboardData.certificateStatus =
          this.d_cert.expiration_details.status
        this.dashboardData.certificateNumber = this.d_cert.certificate_number
        if (this.dashboardData.certificateStatus === 'Terminated') {
          this.dashboardData.certificateNumber = 'TERMINATED'
          this.showActivationButt = true
          this.dashboardData.period_elaped = this.getElapsePeriod(this.d_cert.expiration_details)
        } else {
          const today = new Date()
          const expired_date = new Date(this.d_cert.certificate_expiration_date)
          const diff = (expired_date - today) / (1000 * 60 * 60 * 24)

          //console.log('diff:',diff)

          if (diff > this.activationDays) {
            this.showActivationButt = false
            this.dashboardData.period_elaped = 'None'
          } else {
            this.showActivationButt = true
            this.dashboardData.period_elaped = 'About to elapse!'

          }
          if (this.d_cert.certificate_number === null) {
            this.dashboardData.certificateNumber = 'IN PROCESS'
            this.dashboardData.period_elaped = 'None'
          }
        }
      }

      //fee
      const lOBName = this.currentLOBDetails.LOBname.replace('Fertilizer ', '')
      const category = this.dashboardData.production_category

      //console.log('category:' + category)

      this.d_fee.values(this.d_fee).forEach((value) => {
        if (lOBName === 'Distributor') {
          //console.log('days:' + this.dashboardData.total_days)

          if (value.production_category === category) {
            if (value.paymentType === 'Renewal Fee') {
              this.dashboardData.renewal_fee = value.amount
            }
            if (value.paymentType === 'Late Application for renewal fee') {
              if (this.dashboardData.total_days > 30) {
                //For waiving
                /*
                this.dashboardData.penalty = ' Waived(' + value.amount + ')'
                this.dashboardData.total_amount = this.dashboardData.renewal_fee
                this.dashboardData.waiver = 'Waived'
                */
                this.dashboardData.penalty = value.amount
                this.dashboardData.total_amount =
                this.dashboardData.penalty + this.dashboardData.renewal_fee
              } else {
                this.dashboardData.total_amount = this.dashboardData.renewal_fee
              }
            }
          }
          //console.log(value)
        } else {
          console.log('days:' + this.dashboardData.total_days)
          if (value.paymentType === 'Renewal Fee') {
            this.dashboardData.renewal_fee = value.amount
          }
          if (value.paymentType === 'Late Application for renewal fee') {
            if (this.dashboardData.total_days > 30) {
              //For waiving
              /*this.dashboardData.penalty = 'Waived(' + value.amount + ')'
              this.dashboardData.total_amount = this.dashboardData.renewal_fee
              this.dashboardData.waiver = 'Waived'*/
              
              this.dashboardData.penalty = value.amount
              this.dashboardData.total_amount =
              this.dashboardData.penalty + this.dashboardData.renewal_fee
            }
          } else {
            this.dashboardData.total_amount = this.dashboardData.renewal_fee
          }

        }
      })

    },
    initializeCertificateRenewal: function () {
      const postData = this.prePostData

      this.prePostData.lob = this.prePostData.lOB
      this.prePostData.company_name = this.memberData.company_name
      const url = httpServ.getCertificateUrl('/member/certificateInitializationRenewal')
      const resp = httpServ.postFetchWithToken(
        url,
        this.prePostData, //elapsed
        httpServ.getPaymentApiToken()
      )

      resp.then((result) => { })
    },
    activateRenewal: function () {
      //renewal initiaization
      this.initializeCertificateRenewal()
      const postData = this.prePostData

      if (postData.lOB === 'Distributor') {
        postData.production_category = this.d_member.company.production_category
      }

      postData.elapsed = (Math.abs(this.dashboardData.total_days) + 255) * 2

      const url = httpServ.getPaymentUrl('/ledger/renewal')
      const resp = httpServ.postFetchWithToken(
        url,
        this.prePostData, //elapsed
        httpServ.getPaymentApiToken()
      )

      resp.then((result) => {
        //this.$router.push({ name: 'ledger' })
        setTimeout(() => {
          this.$router.push({ name: 'ledger' })
        }, 3000)
      })
      //FATAL: sorry, too many clients already (53300)
    }
  }
}
</script>

<style scoped>
.v-alert--prominent .v-alert__icon.v-icon {
  font-size: 32px;
  color: green;
}

.v-alert {
  color: green !important;
}

.card-header-text {
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.87);
  padding-bottom: 20px;
}

.d-card-height {
  min-height: 500px !important;
}

::v-deep .v-data-table td {
  height: 20px !important;
  font-size: 14px !important;
}

::v-deep .v-data-table th {
  font-size: 12px !important;
}

.reg-guide-text {
  font-size: 13px !important;
}
</style>
